import React, { ChangeEvent, FC, useState } from 'react'
import { bankNames } from '../../helpers/bank'
import { Button, Flex, Form, Input, Select, Steps, Typography } from 'antd'
import PatternNumber from '../../helpers/PatternNumber'

const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);
interface RegisterStep2Props {
	bankCode: string
	isSubmitting: boolean
	prefixInfo: any

	setBankCode: (e: any) => void
	handleSubmit: (step: number, isRequestOTP: boolean) => void
}

const RegisterStep2: FC<RegisterStep2Props> = ({
	bankCode,
	prefixInfo,
	setBankCode,
	isSubmitting,
	handleSubmit,
}) => {

	const preventScroll = (e: TouchEvent) => {
		e.preventDefault();
	};

	const handleDropdownVisibleChange = (open: boolean) => {
		const isMobile = window.innerWidth <= 768; // ตรวจจับ mobile
		if (isMobile) {
			if (open) {
				document.addEventListener('touchmove', preventScroll, { passive: false });
			} else {
				document.removeEventListener('touchmove', preventScroll);
			}
		}
	};

	// const preventScroll = (e: TouchEvent) => {
	// 	e.preventDefault();
	// };

	// const handleDropdownVisibleChange = (open: boolean) => {
	// 	if (isMobileDevice) {
	// 		if (open) {
	// 			document.addEventListener('touchmove', preventScroll, { passive: false });
	// 		} else {
	// 			document.removeEventListener('touchmove', preventScroll);
	// 		}
	// 	}
	// };

	return (
		<>
			<Form.Item
				name="bankCode"
				rules={[{ required: true, message: 'กรุณาเลือกธนาคาร' }]}
				style={{ marginBottom: 12 }}
				hasFeedback>
				<Select
					placeholder="เลือกธนาคารของท่าน ..."
					// showSearch
					optionFilterProp="children"
					// filterOption={(input: any, option: any) =>
					// 	(option?.label ?? '').includes(input)
					// }
					onSelect={setBankCode}
					onDropdownVisibleChange={handleDropdownVisibleChange}
				// dropdownRender={(menu) => (
				// 	<div
				// 		style={{
				// 			maxHeight: '180px', // จำกัดความสูงของ dropdown
				// 			overflowY: 'auto', // เพิ่ม scroll ให้ dropdown
				// 		}}
				// 		onWheel={(e) => e.stopPropagation()} // ป้องกันการเลื่อนของหน้าเว็บเมื่อ scroll ใน dropdown
				// 	>
				// 		{menu}
				// 	</div>
				// )}
				>
					{
						Object.keys(bankNames).filter(vBankCode => vBankCode !== 'PROMPTPAY').map((vBankCode) => (
							prefixInfo.functions.truewalletRegister ? (
								<Select.Option key={vBankCode} value={vBankCode} label={bankNames[vBankCode]}>
									<Flex gap={'small'} align='center'>
										<img
											src={`/bank-logo/${(vBankCode).toLowerCase()}.svg`}
											alt={vBankCode}
											height={16}
											width={16}
										/>
										{bankNames[vBankCode]}
									</Flex>
								</Select.Option>
							) : (
								vBankCode !== 'TRUEWALLET' && (
									<Select.Option key={vBankCode} value={vBankCode} label={bankNames[vBankCode]}>
										<Flex gap={'small'} align='center'>
											<img
												src={`/bank-logo/${(vBankCode).toLowerCase()}.svg`}
												alt={vBankCode}
												height={16}
												width={16}
											/>
											{bankNames[vBankCode]}
										</Flex>
									</Select.Option>
								)
							)
						))
					}
				</Select>
			</Form.Item>
			{bankCode !== "TRUEWALLET" ? (
				<Form.Item
					name="bankNumber"
					rules={[{ required: true, message: 'กรุณากรอกเลขที่บัญชี' }, { pattern: PatternNumber, message: 'กรุณากรอกเป็นตัวเลขเท่านั้น' }]}
					normalize={(value, prevVal, prevVals) => value.replace(/-/g, "").trim()}
					style={{ marginBottom: 12 }}
					hasFeedback>
					<Input placeholder="เลขที่บัญชี" inputMode='numeric' />
				</Form.Item>
			) : (
				<>
					<div className="notice-card warning">
						<div className="notice-card-icon">
							<img src="/bank-logo/truewallet.svg" alt="notice icon" />
						</div>
						<Typography.Text className="notice-card-text">
							ทรูวอลเล็ทจะใช้เบอร์โทรศัพท์ของท่าน<Typography.Text type="warning"><strong>เป็นเลขที่บัญชี</strong></Typography.Text>
						</Typography.Text>
					</div>
				</>
			)}
			<Form.Item
				name="firstName"
				rules={[{ required: true, message: 'กรุณากรอกชื่อ' }, { pattern: /^[^0-9]+$/, message: 'กรุณากรอกเฉพาะตัวอักษรเท่านั้น' }]}
				normalize={(value) => value?.replace(/\s/g, '')}
				style={{ marginBottom: 12 }}
				hasFeedback>
				<Input placeholder="ชื่อ" inputMode='text' />
			</Form.Item>
			<Form.Item
				name="lastName"
				rules={[{ required: true, message: 'กรุณากรอกนามสกุล' }, { pattern: /^[^0-9]+$/, message: 'กรุณากรอกเฉพาะตัวอักษรเท่านั้น' }]}
				normalize={(value) => value?.replace(/\s/g, '')}
				style={{ marginBottom: 16 }}
				hasFeedback>
				<Input placeholder="นามสกุล" inputMode='text' />
			</Form.Item>
		</>
	)
}

export default RegisterStep2
